import * as Sentry from "@sentry/react";

const DSN = "https://20a53e258b910769b8a69de5ef7e46c1@o4511622510739456.ingest.us.sentry.io/4511622598885376";

let initialized = false;

export function initSentry() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
    ],
  });

  window.__lovableEvents = {
    ...(window.__lovableEvents ?? {}),
    captureException: (error, context, options) => {
      Sentry.captureException(error, {
        contexts: context ? { lovable: context } : undefined,
        tags: options?.mechanism ? { mechanism: options.mechanism } : undefined,
        level: options?.severity ?? "error",
      });
    },
  };
}
